<section class="verificacao-seguranca">
  <div class="verificacao-seguranca__box">
    <div class="verificacao-seguranca__header">
      <img
        src="assets/images/omni-logo-2021.png"
        alt="Logo Omni"
        srcset="
          assets/images/omni-logo-2021-2x.png 2x,
          assets/images/omni-logo-2021-3x.png 3x
        "
      />
    </div>

    <div
      class="verificacao-seguranca__content"
      [ngSwitch]="statusVerificacaoAtual"
    >
      <app-bem-vindo *ngSwitchCase="statusVerificacao.BEMVINDO"></app-bem-vindo>

      <app-verificacao-seguranca-identificacao
        (cpf)="changeCpf($event)"
        *ngSwitchCase="statusVerificacao.IDENTIFICACAO"
      ></app-verificacao-seguranca-identificacao>

      <app-termos
        (scrEvent)="autorizarConsultaSCR = $event"
        (termosDeUsoEvent)="termosDeUso = $event"
        *ngSwitchCase="statusVerificacao.VERIFICAR"
      ></app-termos>

      <app-before-selfie
        *ngSwitchCase="statusVerificacao.BEFORE_SELFIE"
      ></app-before-selfie>

      <app-done *ngSwitchCase="statusVerificacao.DONE"></app-done>

      <app-expired-link
        *ngSwitchCase="statusVerificacao.EXPIRED"
      ></app-expired-link>
    </div>

    <div class="verificacao-seguranca__footer">
      <app-gradient-button
        *ngIf="status !== statusVerificacao.DONE && status !== statusVerificacao.EXPIRED"
        [label]="statusVerificacao.BEMVINDO ? 'COMEÇAR' : 'CONTINUAR'"
        (click)="onClickNext()"
        [isDisabled]="isDisabledButtonClick"
        >
      </app-gradient-button>
    </div>
  </div>
</section>

<app-loader-circles *ngIf="isLoading"></app-loader-circles>
